import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { setTokens } from "~/lib/tokens";

// Fragment-delivered handoff from /api/auth/callback. The API redirects
// here with both access + refresh tokens in the URL fragment so they
// never hit server access logs (fragments are stripped before request
// transmission). This route parses, stores, and bounces the user to
// the return_to path also carried in the fragment.
//
// Uses window.location.replace for the post-store navigation so the
// fragment (containing the tokens) drops out of browser history. A
// hard reload at this point is fine — there's no React state to lose
// immediately after login.

export const Route = createFileRoute("/login_/complete")({
  component: LoginComplete,
});

function LoginComplete() {
  useEffect(() => {
    const fragment = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;
    const params = new URLSearchParams(fragment);
    const accessToken = params.get("access_token");
    const refreshToken = params.get("refresh_token");
    const returnTo = params.get("return_to") ?? "/";

    if (accessToken === null || refreshToken === null) {
      window.location.replace("/login?error=invalid_login");
      return;
    }

    setTokens(accessToken, refreshToken);
    window.location.replace(returnTo);
  }, []);

  return (
    <main style={{ padding: "2rem", textAlign: "center" }}>
      <p>Signing you in…</p>
    </main>
  );
}
